import en from 'browser/translations/en';
import pl from 'browser/translations/pl';

export default {
  ...en,
  ...pl,
};
